export default __webpack_public_path__ + "static/news-img2-49fc16c9dab9f73a69cb8dfbf084691e.png";